/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, toRefs, ref, computed } from '@vue/composition-api';
import { CheckCircleFilledIcon, ErrorCircleFilledIcon } from 'tdesign-icons-vue';
import { abridgeName, getFileSizeText } from '../../_common/js/upload/utils.js';
import { Button } from '../../button/index.js';
import { commonProps } from '../constants.js';
import useCommonClassName from '../../hooks/useCommonClassName.js';
import { Loading } from '../../loading/index.js';
import useDrag from '../hooks/useDrag.js';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.js';
import { ImageViewer } from '../../image-viewer/index.js';
import '../../_common/js/log/log.js';
import '../../button/button.js';
import '../../button/props.js';
import '../../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/ripple.js';
import '../../_common/js/utils/set-style.js';
import '../../config.js';
import '../../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../../utils/mixins.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../../utils/easing.js';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../../loading/plugin.js';
import '../../button/type.js';
import '../../config-provider/useConfig.js';
import '../../hooks/useConfig.js';
import '../../image-viewer/image-viewer.js';
import '../../image-viewer/props.js';
import '../../image-viewer/base/Container.js';
import '../../image-viewer/base/ImageModalIcon.js';
import '../../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import '../../hooks/render-tnode.js';
import 'lodash/isObject';
import '../../image-viewer/base/ImageViewerUtils.js';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../_chunks/dep-9d6f3de6.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import '../../utils/helper.js';
import '../../popup/container.js';
import '../../utils/map-props.js';
import '../../tooltip/type.js';
import '../../image-viewer/utils.js';
import '../../image-viewer/base/ImageItem.js';
import '../../image-viewer/hooks.js';
import '../../image-viewer/base/ImageViewerModal.js';
import '../../dialog/index.js';
import '../../dialog/dialog.js';
import 'lodash/isNumber';
import 'lodash/throttle';
import '../../dialog/actions.js';
import '../../dialog/props.js';
import '../../utils/event.js';
import '../../hooks/useDestroyOnClose.js';
import '../../dialog/stack.js';
import '../../dialog/type.js';
import '../../dialog/plugin.js';
import '../../hooks/useVModel.js';
import '../../hooks/useDefaultValue.js';
import '../../image-viewer/const.js';
import '../../image-viewer/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DraggerFile = defineComponent({
  name: "UploadDraggerFile",
  props: _objectSpread(_objectSpread({}, commonProps), {}, {
    trigger: Function,
    triggerUpload: Function,
    uploadFiles: Function,
    cancelUpload: Function,
    dragEvents: Object
  }),
  setup: function setup(props) {
    var _toRefs = toRefs(props),
        displayFiles = _toRefs.displayFiles;

    var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames;

    var uploadPrefix = "".concat(props.classPrefix, "-upload");
    var drag = useDrag(props.dragEvents);
    var dragActive = drag.dragActive;
    var draggerFileRef = ref();
    var classes = computed(function () {
      var _displayFiles$value$;

      return ["".concat(uploadPrefix, "__dragger"), _defineProperty({}, "".concat(uploadPrefix, "__dragger-center"), !displayFiles.value[0]), _defineProperty({}, "".concat(uploadPrefix, "__dragger-error"), ((_displayFiles$value$ = displayFiles.value[0]) === null || _displayFiles$value$ === void 0 ? void 0 : _displayFiles$value$.status) === "fail")];
    });
    var icons = useGlobalIcon({
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon
    });
    return {
      drag: drag,
      dragActive: dragActive,
      draggerFileRef: draggerFileRef,
      classes: classes,
      sizeClassNames: sizeClassNames,
      uploadPrefix: uploadPrefix,
      icons: icons
    };
  },
  methods: {
    renderImage: function renderImage() {
      var h = this.$createElement;
      var file = this.displayFiles[0];
      if (!file) return null;
      return h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-img-wrap")
      }, [file.url && h(ImageViewer, {
        "attrs": {
          "images": [file.url],
          "trigger": function trigger(h2, _ref3) {
            var open = _ref3.open;
            return h("img", {
              "attrs": {
                "src": file.url
              },
              "on": {
                "click": open
              },
              "style": {
                maxWidth: "100%",
                maxHeight: "100%"
              }
            });
          }
        },
        "style": {
          maxWidth: "120px",
          maxHeight: "120px"
        }
      })]);
    },
    renderUploading: function renderUploading() {
      var h = this.$createElement;
      var file = this.displayFiles[0];
      if (!file) return null;

      if (file.status === "progress") {
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__single-progress")
        }, [h(Loading), h("span", {
          "class": "".concat(this.uploadPrefix, "__single-percent")
        }, [file.percent, "%"])]);
      }
    },
    renderMainPreview: function renderMainPreview() {
      var _this = this,
          _this$locale;

      var h = this.$createElement;
      var file = this.displayFiles[0];
      if (!file) return null;
      var _this$icons = this.icons,
          CheckCircleFilledIcon = _this$icons.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$icons.ErrorCircleFilledIcon;
      var fileName = this.abridgeName ? abridgeName(file.name, this.abridgeName[0], this.abridgeName[1]) : file.name;
      return h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-progress")
      }, [this.theme === "image" && this.renderImage(), h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-progress-info")
      }, [h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-text")
      }, [h("span", {
        "class": "".concat(this.uploadPrefix, "__single-name")
      }, [fileName]), file.status === "progress" && this.renderUploading(), file.status === "success" && h(CheckCircleFilledIcon), file.status === "fail" && h(ErrorCircleFilledIcon)]), h("small", {
        "class": "".concat(this.sizeClassNames.small)
      }, [this.locale.file.fileSizeText, "\uFF1A", getFileSizeText(file.size)]), h("small", {
        "class": "".concat(this.sizeClassNames.small)
      }, [this.locale.file.fileOperationDateText, "\uFF1A", file.uploadTime || "-"]), h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-btns")
      }, [["progress", "waiting"].includes(file.status) && !this.disabled && h(Button, {
        "attrs": {
          "theme": "primary",
          "variant": "text"
        },
        "class": "".concat(this.uploadPrefix, "__dragger-progress-cancel"),
        "on": {
          "click": function click(e) {
            var _this$cancelUpload;

            return (_this$cancelUpload = _this.cancelUpload) === null || _this$cancelUpload === void 0 ? void 0 : _this$cancelUpload.call(_this, {
              e: e,
              file: _this.toUploadFiles[0] || _this.files[0]
            });
          }
        }
      }, [(_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.cancelUploadText]), !this.autoUpload && file.status === "waiting" && h(Button, {
        "attrs": {
          "variant": "text",
          "theme": "primary",
          "disabled": this.disabled
        },
        "on": {
          "click": function click() {
            var _this$uploadFiles;

            return (_this$uploadFiles = _this.uploadFiles) === null || _this$uploadFiles === void 0 ? void 0 : _this$uploadFiles.call(_this);
          }
        },
        "class": "".concat(this.uploadPrefix, "__dragger-upload-btn")
      }, [this.locale.triggerUploadText.normal])]), ["fail", "success"].includes(file === null || file === void 0 ? void 0 : file.status) && !this.disabled && h("div", {
        "class": "".concat(this.uploadPrefix, "__dragger-btns")
      }, [h(Button, {
        "attrs": {
          "theme": "primary",
          "variant": "text",
          "disabled": this.disabled
        },
        "class": "".concat(this.uploadPrefix, "__dragger-progress-cancel"),
        "on": {
          "click": this.triggerUpload
        }
      }, [this.locale.triggerUploadText.reupload]), h(Button, {
        "attrs": {
          "theme": "danger",
          "variant": "text",
          "disabled": this.disabled
        },
        "class": "".concat(this.uploadPrefix, "__dragger-delete-btn"),
        "on": {
          "click": function click(e) {
            return _this.onRemove({
              e: e,
              index: 0,
              file: file
            });
          }
        }
      }, [this.locale.triggerUploadText["delete"]])])])]);
    },
    renderDefaultDragElement: function renderDefaultDragElement() {
      var _this$locale$triggerU;

      var h = this.$createElement;
      var unActiveElement = h("div", [h("span", {
        "class": "".concat(this.uploadPrefix, "--highlight")
      }, [(_this$locale$triggerU = this.locale.triggerUploadText) === null || _this$locale$triggerU === void 0 ? void 0 : _this$locale$triggerU.normal]), h("span", ["\xA0\xA0/\xA0\xA0", this.locale.dragger.draggingText])]);
      var activeElement = h("div", [this.locale.dragger.dragDropText]);
      return this.dragActive ? activeElement : unActiveElement;
    },
    getContent: function getContent() {
      var _this$$scopedSlots$de, _this$$scopedSlots;

      var h = this.$createElement;
      var file = this.displayFiles[0];

      if (file && ["progress", "success", "fail", "waiting"].includes(file.status)) {
        return this.renderMainPreview();
      }

      return h("div", {
        "class": "".concat(this.uploadPrefix, "__trigger"),
        "on": {
          "click": this.triggerUpload
        }
      }, [((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null)) || this.renderDefaultDragElement()]);
    }
  },
  render: function render() {
    var _this$trigger;

    var h = arguments[0];
    return h("div", {
      "ref": "draggerFileRef",
      "class": this.classes,
      "on": {
        "drop": this.drag.handleDrop,
        "dragenter": this.drag.handleDragenter,
        "dragover": this.drag.handleDragover,
        "dragleave": this.drag.handleDragleave
      }
    }, [((_this$trigger = this.trigger) === null || _this$trigger === void 0 ? void 0 : _this$trigger.call(this, h, {
      files: this.displayFiles,
      dragActive: this.dragActive
    })) || this.getContent()]);
  }
});

export { DraggerFile as default };
//# sourceMappingURL=dragger-file.js.map
